import { ActionIcon, Popover } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { IconMenu2 } from '@tabler/icons-react';
import cs from 'classnames';
import { useRouter } from 'next/router';
import React, { useRef } from 'react';
import { CloseCircle } from 'solar-icons';
import { useOnClickOutside } from 'usehooks-ts';
import { usePrepareBurgerMenuData } from '@/Module/DefaultLayout/Hook';
import { HamburgerItems, HamburgerMenuCategory } from '@/Module/DefaultLayout/Model';
import { useAppSelector } from '@/Module/Store/Hook';
const BurgerMenuDesktop = () => {
  const router = useRouter();
  const MenuData = usePrepareBurgerMenuData();
  const [opened, {
    close,
    open
  }] = useDisclosure();
  const ref = useRef(null);
  const unRead = useAppSelector(state => state.notification.totalUnreadMenu);
  useOnClickOutside(ref, () => close());
  return <Popover opened={opened} closeOnClickOutside width={234} position="bottom" offset={5} classNames={{
    dropdown: 'shadow-burgerMenu rounded-[10px]'
  }} data-sentry-element="Popover" data-sentry-component="BurgerMenuDesktop" data-sentry-source-file="BurgerMenuDesktop.tsx">
      <Popover.Target data-sentry-element="unknown" data-sentry-source-file="BurgerMenuDesktop.tsx">
        <ActionIcon onClick={() => open()} className="bg-transparent hover:bg-blueFour" size="xl" aria-label="MenuBar" data-sentry-element="ActionIcon" data-sentry-source-file="BurgerMenuDesktop.tsx">
          <IconMenu2 stroke={2} size={40} data-sentry-element="IconMenu2" data-sentry-source-file="BurgerMenuDesktop.tsx" />
        </ActionIcon>
      </Popover.Target>
      <Popover.Dropdown ref={ref} p={16} data-sentry-element="unknown" data-sentry-source-file="BurgerMenuDesktop.tsx">
        <div className="mb-4 flex items-center justify-between border-b-[0.5px] border-grayOne pb-3">
          <p className="text-sm font-medium text-blueFive"> سامانه آموزش مجازی آی‌نو</p>
          <ActionIcon unstyled onClick={() => close()} data-sentry-element="ActionIcon" data-sentry-source-file="BurgerMenuDesktop.tsx">
            <CloseCircle color="black" width={20} height={20} data-sentry-element="CloseCircle" data-sentry-source-file="BurgerMenuDesktop.tsx" />
          </ActionIcon>
        </div>
        {MenuData.map(menuGroup => <div key={menuGroup.categoryId} className={cs(`${menuGroup.categoryId === HamburgerMenuCategory.EXIT && 'grow flex flex-col justify-end mb-6'}`)}>
            <p key={menuGroup.categoryId} className="mb-3 text-right text-xs text-blackThree">
              {menuGroup.categoryName}
            </p>
            {menuGroup.children.map(item => <div key={`${menuGroup.categoryId} - ${item.itemId}`} className="relative">
                <button type="button" key={item.itemId} onClick={() => {
            router.push(item.link).then(() => close());
          }} className={cs('flex items-center justify-start gap-2 text-xs font-medium not-italic leading-[normal]', `${item.itemId === HamburgerItems.EXIT ? 'text-redTwo' : 'text-blackFive hover:text-orangeFour duration-200 transition '}`, `${item.itemId === HamburgerItems.CONTACTUS && 'mb-8'}`)}>
                  {item.icon}
                  {item.itemName}
                </button>
                {item.itemId === HamburgerItems.NOTIFICATION && unRead > 0 && <div className="absolute left-4 top-0 flex h-[20px] w-[20px] items-center justify-center rounded-full bg-redTwo pt-1 text-[12px] text-white sm:left-0">
                    {unRead}
                  </div>}
                {item.itemId !== HamburgerItems.EXIT && item.itemId !== HamburgerItems.CONTACTUS && <div className="my-4 h-[1px] min-w-full bg-grayOne" />}
              </div>)}
          </div>)}
      </Popover.Dropdown>
    </Popover>;
};
export default React.memo(BurgerMenuDesktop);